
import "./internal.css";
import { useState, useEffect } from "react";

/* banco de dados */
import { db } from "../../services/firebaseConnection";
import { collection, doc, setDoc, addDoc, getDocs } from "firebase/firestore";

export default function Details() {

    async function criar_plano(data) {
        try {
            let dt = new Date();

            const plandoc = await addDoc(collection(db, "plans"), { 
                codigo: "EST1",
                ramo: "Esteticistas",
                atendimento: "W",
                valor: 6,
                data_criacao: dt,
                data_inicio_vigencia: dt,
                data_termino_vigencia: new Date("2100-12-31T23:59:59Z"),
            });

        } catch (erro) {
            console.log(erro);
        }
    }


async function migrarMedical() {

    try {

        const snap = await getDocs(collection(db, "medical"));

        console.log("Documentos encontrados:", snap.size);

        for (const document of snap.docs) {

            const data = document.data();

            // cria na coleção nova
            await addDoc(collection(db, "medical"), data);

            // opcional: apagar da antiga
            // await deleteDoc(doc(db, "medical_", document.id));

            console.log("Migrado:", document.id);
        }

        console.log("Migração concluída!");

    } catch (error) {
        console.log("Erro na migração:", error);
    }

}



    return(
        <div>
            <span>Para criar um plano</span>
            <br /><br />
            <div><button input="button" onClick={criar_plano}>Criar Plano</button></div>
            <br /><br />
            <span>Para criar uma agenda de testes</span>
            <br /><br />
            <div><button input="button" onClick={migrarMedical}>Dados</button></div>
        </div>
    )
}
